import { useEffect, useState } from "react";
import http from "../../../config/BaseUrl";

const useGalleryMediaDetails = (mediaId, initialDetails) => {
  const [media, setMedia] = useState(initialDetails?.media || null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!mediaId) {
      setMedia(initialDetails?.media || null);
      return undefined;
    }

    let mounted = true;
    setLoading(true);

    http.get(`media/item-details?media_id=${mediaId}`)
      .then((response) => {
        if (mounted && response.data?.status === "success") setMedia(response.data.media || null);
      })
      .catch(() => {
        if (mounted) setMedia(initialDetails?.media || null);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => { mounted = false; };
  }, [initialDetails, mediaId]);

  return { loading, media };
};

export default useGalleryMediaDetails;
